import { Trans } from "@lingui/macro";
import { UiModuleLoader } from "@smp/ui";
import { lazy, Suspense } from "react";

import { IProviderPolotnoEditorProps } from "@/components/features/polotno_editor/context/polotno_editor.types";

import { IPolotnoEditorProps } from "./polotno_editor.types";

export * from "./polotno_editor.types";

const Module = lazy(
  () =>
    import(/* webpackChunkName: "polotno_editor" */ "./polotno_editor_lazy"),
);

export const PolotnoEditor = (
  props: IPolotnoEditorProps & Partial<IProviderPolotnoEditorProps>,
) => (
  <Suspense fallback={<UiModuleLoader loadingText={<Trans>Loading</Trans>} />}>
    <Module {...props} />
  </Suspense>
);
